<template>
  <StaticPageLayout
    title="Privacy"
    subtitle="What gets stored, what does not, and what actually happens with your data."
    lastUpdated="March 19, 2026"
  >
    <p>
      Short version:
      <strong>I collect the minimum needed to make this work.</strong>
      Nothing is sold, nothing weird is happening behind the scenes.
    </p>

    <h2>What data is collected?</h2>

    <p>
      Depends on what you do on the site.
    </p>

    <h3>Accounts</h3>
    <p>
      If you create an account, some basic account data has to exist.
      That can include your login identity and, if you link it, your Steam ID.
    </p>

    <h3>Steam profiles</h3>
    <p>
      If you enter or link a Steam profile, the app uses it to load your library for Steam mode.
    </p>

    <ul>
      <li>No, this site does not need your Steam password</li>
      <li>If you unlink your account, it stops using it</li>
      <li>If you paste a Steam ID manually, it just loads that profile</li>
    </ul>

    <h3>Search and usage</h3>
    <p>
      Searches, filters, and some basic logs may be stored.
      Mostly for debugging, improving results, and making sure things do not break.
    </p>

    <p>
      Bad queries are actually useful. They help fix bad results.
    </p>

    <h3>Browser storage</h3>
    <p>
      Some things are stored in your browser so the app remembers what you did.
    </p>

    <ul>
      <li>search count</li>
      <li>survey completion</li>
      <li>filter preferences (anime, adult, VR)</li>
      <li>small UI state</li>
    </ul>

    <p>
      This is just to avoid resetting everything every time you reload.
    </p>

    <h2>What is not happening?</h2>

    <ul>
      <li>No selling your data</li>
      <li>No ad-tech tracking circus</li>
      <li>No building profiles to follow you around the internet</li>
    </ul>

    <h2>Third-party stuff</h2>

    <p>
      The site uses normal infrastructure.
      That means hosting, databases, auth providers, logging tools, and similar services.
    </p>

    <p>
      Data passes through those systems because that is how websites work.
      Nothing exotic there.
    </p>

    <h2>Payments</h2>
    <p>
      Support goes through Patreon.
      This site does not handle your payment details directly.
    </p>

    <h2>Cookies</h2>
    <p>
      Yes, there are cookies.
      Mostly for keeping sessions alive and remembering basic state.
    </p>

    <p>
      They are not used to build some massive advertising profile.
    </p>

    <h2>How long is data kept?</h2>

    <p>
      As long as it is useful.
      For running the service, fixing issues, and not letting everything fall apart.
    </p>

    <h2>Can you control your data?</h2>

    <ul>
      <li>You can unlink your Steam account</li>
      <li>You can clear browser storage anytime</li>
      <li>You can contact me for account or data questions</li>
    </ul>

    <h2>Security</h2>

    <p>
      Reasonable effort is made to keep things secure.
      Reasonable effort is not the same as perfect security.
    </p>

    <p>
      If something on the internet tells you it is perfectly secure, it is lying.
    </p>

    <h2>Other sites</h2>

    <p>
      This site links to other sites.
      Those sites have their own rules and policies.
    </p>

    <p>
      Once you leave this site, it is not my problem anymore.
    </p>

    <h2>Changes</h2>

    <p>
      This page might change over time.
      If it does, the date at the top will change too.
    </p>

    <h2>Contact</h2>

    <p>
      Privacy questions or concerns:
      <br />
      <a href="mailto:contact@gamepivot.net">contact@gamepivot.net</a>
    </p>
  </StaticPageLayout>
</template>

<script>
import StaticPageLayout from './StaticPageLayout.vue';

export default {
  name: 'PrivacyPage',
  components: {
    StaticPageLayout
  }
};
</script>